import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { completar_String } from '../../funciones_globales/format';

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

const ContenedorModal = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 650px;
`;

class FormCon04 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Estados formulario
            operacion: 'G', //G & M
            permiso: 'G',
            ult_transaccion: null,
            num_diario: null,
            movimientoId: '',
            cod_proveedor: null,

            //FECHAS
            fechaProceso: null,
            fechaImportacionIni: null,
    
            //MISC
            errorAjusteExistente: null,

            //REACTSELECT
            importacion_sel: null,

            //InputText
            totalEstimado: '',
            totalReal: '',
            MovBanco: '',
            difAjuste: '',

            //Modal
            isOpenMovBanco: false,

            //Grids
            detMovBancoImp: [],
            detAjusteGastosImp: [],
            columnsDefMovBancoImp: [
                                    {
                                        header:"Mov.",
                                        field: "Movimiento",
                                        width: 50,
                                        type: "string"
                                    },
                                    {   header: "Fecha Doc.",
                                        field: "FechaDocumento",
                                        width: 65,
                                        type: "fecha"
                                    },
                                    {   header: "Cuenta",
                                        field: "Cuenta",
                                        width: 70,
                                        type: "string"
                                    },
                                    {   header: "Nombre",
                                        field: "Nombre",
                                        width: 390,
                                        type: "string"                                         
                                    },
                                    {   header: "Valor",
                                        field: "Valor",
                                        width: 60,
                                        type: "num_decimal"                                         
                                    }],
            columnsDefGridAjusteGasto: [
                                        {   header: "Secuencia",
                                            field: "Secuencia",
                                            width: 80,
                                            type: "string",
                                        },
                                        {
                                            header:"Observación",
                                            field: "Observacion",
                                            width: 385,
                                            type: "string"
                                        },
                                        {   header: "G. Estimados",
                                            field: "Estimado",
                                            width: 90,
                                            type: "num_decimal"
                                        },
                                        {   header: "G. Real",
                                            field: "Real",
                                            width: 90,
                                            type: "num_decimal"                                         
                                        },
                                        {   header: "Diferencia",
                                            field: "Diferencia",
                                            width: 90,
                                            type: "num_decimal"                                         
                                        }
                                    ] 
        };

        this.ajusteGastosOptions = {
            context: {
                componentParent: this
            },
            enableCellChangeFlash: true,
            enableColResize: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{}),
            onCellEditingStarted:((event)=> {
            })
        };

        this.movBancoImpOptions = {
            context: {
                componentParent: this
            },
            enableCellChangeFlash: true,
            enableColResize: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{}),
            onCellEditingStarted:((event)=> {
            })
        };

        //Get
        this.getGastosRealesImport = this.getGastosRealesImport.bind(this)
        this.totalizarColumGrid = this.totalizarColumGrid.bind(this);

        //Operaciones
        this.guardarAjusteGastoImp = this.guardarAjusteGastoImp.bind(this);
        this.getAjusteIMPById = this.getAjusteIMPById.bind(this);
        this.anularAjusteGastoImp = this.anularAjusteGastoImp.bind(this);
        this.onGridAjusteGastosIMPReady = this.onGridAjusteGastosIMPReady.bind(this);
        //Modal
        this.toggleModalMovBanco = this.toggleModalMovBanco.bind(this);

        //OverControls
        this.actualizarCampos = this.actualizarCampos.bind(this);
        //IMP REPORTE
        this.impCostosImpVsReales = this.impCostosImpVsReales.bind(this);
    }

    //OVERCONTROLS
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    //GET
    getAjusteIMPById(){
        if(this.state.movimientoId === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movimientoId,10) <= 0 ){
            alert("Movimiento no válido");
            this.setState({movimientoId: ''});
        }else{
            this.props.cambiar_VisualizacionLoading(true);
            global_axios({
                method: 'GET',
                url: '/importaciones/gastosreales/'+this.state.movimientoId.toString()
            })
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                var ajuste = response.data;
                
                if(ajuste!==null){
                    console.log("FECHA: ", ajuste)
                    //LOAD FECHA
                    this.setState({fechaProceso: moment(ajuste.FechaProceso, "DD/MM/YYYY")});

                    this.cargarObjetos('/importaciones?compra=1&cadena_busq='+ajuste.Importacion).then((resultImp)=>{
                        console.log("IMP: ", resultImp[0])
                        var Import = {}
                        Import.value = resultImp[0].Codigo;
                        Import.label = resultImp[0].Codigo+' ('+resultImp[0].Descripcion+')';

                        this.setState({importacion_sel: Import, operacion: 'M'}, ()=>{
                            this.getGastosRealesImport();
                            console.log("IMPTP:", this.state.importacion_sel)

                        })
                    })
                }else{
                    alert("El ajuste no existe o esta anulado")
                }
            })
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);               
                alert(error.response?error.response.data.msg:error.message);      
            });

        }
    }

    getGastosRealesImport(){
        if(this.state.importacion_sel!==null){
            var gastosEstimados = 0;
            var gastosReales = 0;
            var MovBancoTotal = 0;
            const Importacion = this.state.importacion_sel.value;

            //CARGA DATOS DE IMP
            this.cargarObjetos('/importaciones?importacion='+Importacion+'&resumido=true').then((resultImpResume)=>{
                
                if(resultImpResume===null){
                    alert("Importación con datos incorrectos")
                }else{
                    let item = {};
                    item.value = resultImpResume.Proveedor;
                    item.label = resultImpResume.prov!==null?resultImpResume.prov.Nombre:'N/A';
                    this.setState({cod_proveedor: item, fechaImportacionIni: moment(resultImpResume.FechaInicio, "DD/MM/YYYY")})
                        
                    //VERIFICA SI YA EXISTE ESTA IMPORTACION COMO UN AJUSTE YA INGRESADO
                    this.cargarObjetos('/importaciones/'+Importacion+'/gastosreales?verificacion=true').then((resultImpAjust)=>{
                        if(resultImpAjust.length > 0){
                            this.setState({errorAjusteExistente: 1})
                            alert("Importacion #: "+Importacion+" ya ha sido ajustada, si desea re-ajustar anule el ajuste #: "+resultImpAjust[0].Secuencia)
                        }

                        //Carga GRID DE GASTOS ESTIMADOS
                        this.cargarObjetos('/importaciones/'+Importacion+'/gastosreales?estimados=true').then((resultImp)=>{
                            this.setState({detAjusteGastosImp: resultImp}, ()=>{
                                gastosEstimados = this.totalizarColumGrid('Estimado')
                                gastosReales = this.totalizarColumGrid('Real')

                                this.setState({totalEstimado: Math.round(gastosEstimados*100)/100,
                                    totalReal: Math.round(gastosReales*100)/100})
                            })

                            //Carga de Movimientos de banco
                            console.log("FUNC IMP2: ",this.state.importacion_sel)
                            this.cargarObjetos('/importaciones/'+Importacion+'/gastosreales?movbanco=true').then((resulMovBanco)=>{
                                if(resulMovBanco.length === 0){
                                    this.setState({MovBanco: 0});
                                }else{
                                    resulMovBanco.forEach((DATA)=>{
                                        MovBancoTotal = MovBancoTotal + parseFloat(DATA.Valor)
                                    })
                                    this.setState({MovBanco: Math.round(MovBancoTotal*100)/100, detMovBancoImp: resulMovBanco})
                                }

                                //CALCULO DE LA DIFERENCIA
                                var total = 0;
                                total = gastosEstimados - (gastosReales+MovBancoTotal)
                                this.setState({difAjuste: Math.round(total*100)/100});
                            })
                        })
                    })
                }
            })
        }
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?compra=1&cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Methods
    onGridAjusteGastosIMPReady(params){
        this.apiAjusteGastosIMP = params.api;
        this.columnApiAjusteGastosIMP = params.columnApi;
    }

    onGridmovBancoImpReady(params){
        this.apimovBancoImpIMP = params.api;
        this.columnApimovBancoImp = params.columnApi;
    }

    //Columna Envia, retorna valor
    totalizarColumGrid(name){
        var acc = 0;
        this.state.detAjusteGastosImp.forEach((DET)=>{
            acc = acc + parseFloat(DET[name])
        })
        return acc;
    }

    clear(){        
        //FECHA DE PROCESO POR MODULO
        let fechaProceso = getFechaProcesoPorModulo('08');

        this.setState({cod_proveedor: null, fechaProceso: moment(fechaProceso, "DD/MM/YYYY"),
        fechaImportacionIni: null, errorAjusteExistente: null, 
        importacion_sel: null, totalEstimado: '',
        totalReal: '',
        MovBanco: '',
        difAjuste: '', isOpenMovBanco: false, detMovBancoImp: [],
        detAjusteGastosImp: [],
        operacion: 'G'})

    }

    //CICLO REACT
    componentDidMount(){
        Promise.all([
            this.cargarObjetos('/secuenciales/AjusteImportacion'),
            this.props.generar_LogAuditoriaIngresoForm('0804')
         ])
        .then(([secAjusteImp])=>{
            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('08');
   
            this.setState({ult_transaccion: completar_String(secAjusteImp.codigo -1, '0', 6), permiso: this.props.permiso, 
            fechaProceso: moment(fechaProceso, "DD/MM/YYYY")})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0804');
    }

    //Operacion Buttons
    guardarAjusteGastoImp(){
        var errors = "";
        var proceder = true;

        let fechaProceso = getFechaProcesoPorModulo('08');
        
        // Validación de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        //Validación de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        console.log("PERMISO: ",operacion)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        //Validación campos
        var diferencia = 0;
        if(isNaN(parseFloat(this.state.difAjuste))===false){
            diferencia = Math.round(parseFloat(this.state.difAjuste)*100)/100;
        }

        if(diferencia===0){
            proceder = false;
            errors = errors+"- La diferencia tiene que ser mayor a 0 para continuar"
        }
        //console.log("PROCEDER: ",proceder)
        if(proceder === true){
            var data = {};
            data.Localidad = '01';
            data.Importacion = this.state.importacion_sel.value;
            data.Valor = diferencia;
            data.FechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);
            data.Usuario = this.props.usuario;
            data.Status = 'V';

            let config_request = {
                method: 'POST',
                url: '/importaciones/'+data.Importacion+'/gastosreales',
                data
            }
            console.log("DATA A ENVIAR: ", data)
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=> {  
                if(response){
                    this.props.cambiar_VisualizacionLoading(false);  
                    console.log("DATA RECIBIDA: ", response)           
                    alert(response.data.msg);
                    this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario})
                    this.limpiarPantalla('A');
                    this.setState({movimientoId: response.data.transaction})
                    this.getAjusteIMPById();
                }else{
                    alert('Error al cargar los datos')
                }              
            })
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                           
                alert(error.response?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }
    }
    
    limpiarPantalla(param){
        this.clear();
        this.setState({detAjusteGastosImp: [], operacion: 'G'});
        
        if(param==='A'){
            this.setState({movimientoId: ''});
        }
    }

    anularAjusteGastoImp(){
        var errors = "";
        var proceder = true;

        //Validación de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(proceder === true){
            var data = {};
            data.Localidad = '01';
            data.Importacion = this.state.importacion_sel.value;
            data.FechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);
            data.Usuario = this.props.usuario;
            data.IdAuditoria = this.props.IdRegAudit;
            
            this.props.cambiar_VisualizacionLoading(true);
            global_axios({
                url: '/importaciones/gastosreales/'+this.state.movimientoId,
                method: 'PUT',
                data
              })
              .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg);
                this.setState({ult_transaccion: response.data.transaction})
                this.limpiarPantalla('A');
                this.setState({operacion: 'G'});
              })
              .catch((error)=>{                
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }
    }

    //MODALS
    toggleModalMovBanco(){
        this.setState({
            isOpenMovBanco: !this.state.isOpenMovBanco})
    }

    //IMP REPORTE
    impCostosImpVsReales(){
        visualizarReporteEnPdf('&rpt=45&param1='+this.state.importacion_sel.value)
    }

    render(){
        return(
            <ContenedorForm porc_ancho={80}>
             <HeaderForm>
                <TituloForm>Ajuste de gastos de importación</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario: {this.state.num_diario}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-sm-2' >
                                <LabelForm>Movimiento:</LabelForm>
                                <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId} func_CambiarValor={this.actualizarCampos} 
                                func_BuscarValor={this.getAjusteIMPById} func_OnFocus={()=>{this.limpiarPantalla('B')}} maxLength='10'/> 
                            </ContainerCol>                          
                            <ContainerCol className='col-sm-2 col-md-offset-8'>
                                <LabelForm>Fecha:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} 
                                func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row> 
                        <ContainerCol className='col-sm-3'>
                            <ContainerCol className='col-sm-12'>
                                <LabelForm>Importación:</LabelForm>
                                <ReactSelectAsync value={this.state.importacion_sel} disabled={this.state.operacion==='M'?true:false} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}} func_onBlur={this.getGastosRealesImport}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-12' margen_arriba='4'>
                                <LabelForm>Proveedor:</LabelForm>
                                <ReactSelectAsync value={this.state.cod_proveedor} disabled={true} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>this.setState({cod_proveedor: value!==null?value:null})}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-12' margen_arriba='4'>
                                <LabelForm>Fecha Inicial:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaImportacionIni} disabled={true} 
                                func_onChange={(fechaEscogida)=>{this.setState({fechaImportacionIni: fechaEscogida})}}/>
                            </ContainerCol>


                            <ContainerCol className='col-sm-12' margen_arriba='45'>
                                <LabelForm>Total Estimado:</LabelForm>
                                <InputText ancho='64' name='totalEstimado' type="text" value={this.state.totalEstimado} disabled={true} className='form-control input-sm'/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-12' margen_arriba='4'>
                                <LabelForm>Total Real:</LabelForm>
                                <br/>
                                <InputText ancho='64' name='totalReal' type="text" value={this.state.totalReal} disabled={true} className='form-control input-sm'/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4' margen_arriba='4'>
                                <LabelForm>Movimiento Banco:</LabelForm>
                                <div className='input-group'>
                                    <InputText name='MovBanco' type="text" value={this.state.MovBanco} disabled={true} className='form-control input-sm'/>
                                    <span className='input-group-btn'>
                                        <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.toggleModalMovBanco}><i className='fa fa-tasks'></i></ButtonUnion>
                                    </span>
                                </div>
                                
                            </ContainerCol>
                            <ContainerCol className='col-sm-12' margen_arriba='4'>
                                <LabelForm>Diferencia a Ajustar:</LabelForm>
                                <InputText ancho='64' name='difAjuste' type="text" value={this.state.difAjuste} disabled={true} className='form-control input-sm'/>
                            </ContainerCol>

                        </ContainerCol>
                        <ContainerCol className='col-sm-9'>
                            <ContainerCol className='col-sm-12'>
                                <AgGridRender altura='400px' data={this.state.detAjusteGastosImp} columnas={this.state.columnsDefGridAjusteGasto}
                                gridOptions={this.ajusteGastosOptions} onGridReady={this.onGridAjusteGastosIMPReady}/>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <div className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.errorAjusteExistente===1||this.state.operacion==='M'?true:false} onClick={this.guardarAjusteGastoImp}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularAjusteGastoImp}><i className='fa fa-window-close  fa-lg'/> Anular</button> 
                                <button type='button' className='btn btn-default btn-sm' disabled={this.state.importacion_sel!==null?false:true} onClick={this.impCostosImpVsReales}><i className='fa fa-print fa-fw  fa-lg'/> Imprimir</button>                   
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>

                {/*MODAL MovBanco*/}
                <ModalResponsive  open={this.state.isOpenMovBanco} onClose={()=>{this.setState({isOpenMovBanco:false})}}>
                    <HeaderForm>
                        <TituloForm>Movimientos de cheques</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal>
                            {/* <Row>
                                <ContainerCol className='col-md-12' style={(this.state.operacion==='M')?visible:invisible}>
                                    <LabelForm>Número del libro: {this.state.ConMovimiento}</LabelForm>
                                </ContainerCol>
                            </Row> */}
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelForm>Movimientos:</LabelForm>
                                    <AgGridRender  altura='140px' data={this.state.detMovBancoImp} columnas={this.state.columnsDefMovBancoImp} gridOptions={this.movBancoImpOptions} onGridReady={this.onGridmovBancoImpReady}/>   
                                </ContainerCol>
                            </Row>
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
        diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,}
});

const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCon04);